<template>
  <div>
    <Row :gutter="10" class="m-b-15">
      <Col span="12">
        <Card style="height:120px">
          <div class="f-22 m-b-10">免费刻章
            <Icon type="md-checkmark" class="m-l-5 c-green" size="38"/>
          </div>
          <div class="c-gray-light">说明：由政府或其他第三方机构为新办企业免费刻章，企业只需要满足约定的条件即可获赠。</div>
        </Card>
      </Col>
    </Row>

    <Row :gutter="10" class="m-b-15">
      <Col span="3" class="p-l-5 ti_line-height-32px">选择单位：</Col>
      <Col span="21">
        <div flex="dir:left cross:center">
          <SelectPro :option-data="payerList" display-style="button"
                     @on-change="changePayer"></SelectPro>
          <Button disabled class="m-l-10">其他第三方机构</Button>
        </div>
      </Col>
    </Row>
    <Row :gutter="10" class="m-b-15">
      <Col span="3" class="p-l-5 ti_line-height-32px">免费刻章条件：</Col>
      <Col span="18" class="ti_line-height-32px">{{freeByPayer.payerSelected &&
        freeByPayer.payerSelected.conditionApply}}
      </Col>
    </Row>
    <Row :gutter="10" class="m-b-15">
      <Col span="3" class="p-l-5 ti_line-height-32px">银行开户网点：</Col>
      <Col span="12">
        <SelectPro :option-data="localeList" @on-change="changeLocale"></SelectPro>
      </Col>
    </Row>
    <Row :gutter="10" class="m-b-15">
      <Col span="3" class="p-l-5 ti_line-height-32px">刻制经营单位：</Col>
      <Col span="12">
        <SelectPro :option-data="companyList"  @on-change="changeCompany"></SelectPro>
      </Col>
    </Row>

    <Row :gutter="10" class="m-b-15">
      <Col span="12">
        <Card title="银行开户网点" dis-hover>
          <div class="c-gray-light h-32-px">网点名称：{{freeByPayer.localeSelected?freeByPayer.localeSelected.name:''}}</div>
          <div class="c-gray-light h-32-px">
            网点地址：{{freeByPayer.localeSelected?freeByPayer.localeSelected.addrDetail:''}}
          </div>
          <div class="c-gray-light h-32-px">联系电话：{{freeByPayer.localeSelected?freeByPayer.localeSelected.phone:''}}
          </div>
        </Card>
      </Col>
      <Col span="12">
        <Card title="刻制经营单位" dis-hover>
          <div class="c-gray-light h-32-px">单位名称：{{freeByPayer.companySelected?freeByPayer.companySelected.name:''}}
          </div>
          <div class="c-gray-light h-32-px">
            经营地址：{{freeByPayer.companySelected?freeByPayer.companySelected.address:''}}
          </div>
          <div class="c-gray-light h-32-px">联系电话：{{freeByPayer.companySelected?freeByPayer.companySelected.phone:''}}
          </div>
        </Card>
      </Col>
    </Row>

    <Card title="选择印章套餐" dis-hover :padding="0">
      <Row type="flex" justify="center" align="middle" class="b-b-1" v-for="(item, index) in planListData" :key="index"
           @click.native="changePlan(item)"
           :class="(freeByPayer.planSelected && freeByPayer.planSelected.id === item.id)?'bg-gray-2':''">
        <Col span="3" class="f-22 p-16 b-r-1 tb-row-center" style="height: 269px">
          {{item.name}}
          <Icon v-if="freeByPayer.planSelected && freeByPayer.planSelected.id === item.id" type="md-radio-button-on"
                class="m-l-5 c-green" size="42"/>
          <Icon v-else type="md-radio-button-off" class="m-l-5 c-gray-light" size="42"/>
        </Col>
        <Col span="9" class="h-100" align="middle">
          <img :src="item.photoOss|img_oss('tubo_11_fill_medium')" width="270" height="270">
        </Col>
        <Col span="12" class="b-l-1">
          <Row class="f-700">
            <Col span="6" class="p-16 b-r-1">印章类型</Col>
            <Col span="18" class="p-16">印章材质说明</Col>
          </Row>
          <Row class="b-t-1" v-for="(o, i) in item.sealArrayJson" :key="i">
            <Col span="6" class="p-16 b-r-1">{{o.sealType}}</Col>
            <Col span="18" class="p-16">{{o.sealMaterial}}</Col>
          </Row>
        </Col>
      </Row>
    </Card>

    <div class="m-t-20 text-c">
      <Button type="primary" @click="submit" class="m-r-10">提交预约</Button>
      <Button @click="goBack">取消</Button>
    </div>
  </div>
</template>

<script>
  import {SelectPro} from '@/components/libs'
  import {mapState} from 'vuex'
  import {api, http} from '@/libs'
  import lodash from 'lodash'

  export default {
    components: {SelectPro},
    data() {
      return {
        samrId: null,
        payerList: [],          // 买单方案生成的选项列表
        payerListData: null,    // 买单方案列表
        localeList: [],         // 网点生成的选项列表
        localeListData: null,   // 网点列表
        planListData: null,     // 套餐列表
        companyList: [],        // 刻制经营单位生成的选项列表
        companyListData: null,  // 刻制经营单位列表
        freeByPayer: {
          payerSelected: null,
          localeSelected: null,
          planSelected: null,
          companySelected: null,
        },
      }
    },
    props: {},
    computed: {
      ...mapState({}),
    },
    updated() {
    },
    methods: {
      // 买单方发生变化
      changePayer(item) {
        this.payerListData.map(o => {
          if (o.id === item.value) this.freeByPayer.payerSelected = o
        })

        this.freeByPayer.localeSelected = null
        this.freeByPayer.companySelected = null
        this.freeByPayer.planSelected = null

        // 刷新送章网点
        this.localeListData = null
        this.localeList.splice(0, this.localeList.length)
        http.get(api.webCusFree.locale, {params: {payerId: item.value}}).then(payload => {
          this.localeListData = payload
          this.localeListData.forEach(e => this.localeList.push({value: e.id, label: e.name}))
        })

        // 刷新刻制经营单位
        this.companyListData = []
        this.companyList.splice(0, this.companyList.length)

        // 刷新套餐列表
        this.planListData = null
        http.get(api.webCusFree.plan, {params: {payerId: item.value}}).then(payload => {
          this.planListData = payload
        })
      },
      // 配送网点发生变化
      changeLocale(item) {
        console.log("changeLocale, item=", item)
        this.localeListData.map(o => {
          if (o.id === item.value) this.freeByPayer.localeSelected = o
        })

        // 刷新刻制经营单位
        this.companyListData = null
        this.companyListData = lodash.shuffle(this.freeByPayer.localeSelected.companies)
        this.companyList.splice(0, this.companyList.length)
        for (let i = 0; i < this.companyListData.length; i++) {
          this.companyList.push({value: i, label: this.companyListData[i].name})
        }

      },
      // 套餐发生变化
      changePlan(item) {
        console.log("changePlan, item", item)
        this.freeByPayer.planSelected = item
      },
      // 刻章企业发生变化
      changeCompany(item) {
        console.log("changeCompany, item=", item)
        this.freeByPayer.companySelected = this.companyListData[item.value]
      },
      submit() {
        if (!this.freeByPayer.companySelected || !this.freeByPayer.planSelected ||
          !this.freeByPayer.localeSelected || !this.freeByPayer.payerSelected) {
          this.$Message.warning("请完成选择")
        }



        this.$Modal.confirm({
          title: '请确认',
          content: '您是否自愿承诺前往指定的银行营业网点办理企业开户事宜，如无故取消将无法获得免费刻章服务。',
          onOk: () => {
            http.post(api.webCusFree.reservation, {
              samrId: this.samrId,
              payerId: this.freeByPayer.payerSelected.id,
              localeId: this.freeByPayer.localeSelected.id,
              companyId: this.freeByPayer.companySelected.id,
              planId: this.freeByPayer.planSelected.id,
            }).then(() => {
              this.$router.push({path: '/custom/reservation/success'})
            })
          }
        })
      },
      goBack() {
        this.$router.push({path: '/custom/samr/list'})
      }
    },
    created() {
      this.samrId = this.$route.query.id

      http.get(api.webCusFree.payer).then(payload => {
        this.payerListData = payload
        this.payerListData.forEach(e => this.payerList.push({value: e.id, label: e.name}))
        console.log("payerList", payload)
      })
    }
  }
</script>
